import { createFileRoute } from "@tanstack/react-router"

import VariantsTab from "~/components/demand-2/tabs/VariantsTab"
import { FilterScopeProvider } from "~/providers/FilterScopeProvider"

export const Route = createFileRoute("/_auth/demand/fashion/$collectionId/_layout/variants")({
  component: RouteComponent,
})

function RouteComponent() {
  const { collectionId } = Route.useParams()
  // A fixed key: other tabs' links write here, and writes on leaving must not follow the route.
  return (
    <FilterScopeProvider scopeKey={Route.id}>
      <VariantsTab collectionId={Number(collectionId)} kind="fashion" />
    </FilterScopeProvider>
  )
}
